import React, { useRef, useEffect, useState } from 'react';
import './IntroSection.css';

// Import images
import imageCard1 from '../Images/Card2Img.jpeg';
import imageCard3 from '../Images/Card3Img.jpg';
import SmartlightLogoWhite from '../Images/SmartlightLogoWhite.png';
import SmartlightLogoBlue from '../Images/SmartlightLogoBlue.png';

const cardData = [
  {
    title: 'Our Mission',
    text: 'To redefine spaces through pioneering lighting solutions that combine artistry, technology, and unparalleled performance.',
    image: imageCard1
  },
  {
    title: 'Our Vision',
    text: 'To illuminate the future as the world\'s most trusted name in smart, sustainable, and human-centric lighting.',
    bgColor: '#1d354d'
  },
  {
    title: 'Our Values',
    // Text is split to inject the logo
    textBeforeLogo: 'At ',
    textAfterLogo: ', our values guide every light we create. We believe in innovation that blends technology with design, delivering quality solutions that last. Our energy-efficient lighting brightens spaces responsibly. We design with style and integrity to build trust.',
    // Logo configuration
    logoConfig: {
      default: SmartlightLogoBlue, // Blue logo for dark text on light/image background
      hover: SmartlightLogoWhite    // White logo for light text on dark overlay
    },
    image: imageCard3
  }
];

export default function IntroSection() {
  const sectionRef = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setInView(entry.isIntersecting);
      },
      {
        threshold: 0.1 // Animation triggers when 10% of the section is visible
      }
    );

    const currentSectionRef = sectionRef.current;

    if (currentSectionRef) {
      observer.observe(currentSectionRef);
    }

    return () => {
      if (currentSectionRef) {
        observer.unobserve(currentSectionRef);
      }
    };
  }, []);

  return (
    <section className={`intro-section ${inView ? 'is-in-view' : ''}`} ref={sectionRef}>
      <div className="intro-container">
        {cardData.map((card, index) => (
          <div
            key={index}
            className={`intro-card ${card.image ? 'has-image' : ''}`}
            style={{ '--delay-index': index }}
          >
            {card.image ? (
              <div
                className="card-background-image"
                style={{ backgroundImage: `url(${card.image})` }}
              ></div>
            ) : (
              <div
                className="card-background-solid"
                style={{ backgroundColor: card.bgColor }}
              ></div>
            )}

            {card.image && <div className="card-overlay"></div>}

            <div className="intro-card-content">
              <h3 className="intro-card-title">{card.title}</h3>
              {/* Conditional rendering for text: handles normal text or text with logo */}
              {card.logoConfig ? (
                <p className="intro-card-text">
                  {card.textBeforeLogo}
                  <span className="logo-container">
                    <img src={card.logoConfig.default} alt="Smartlight Logo" className="logo-default" />
                    <img src={card.logoConfig.hover} alt="Smartlight Logo" className="logo-hover" />
                  </span>
                  {card.textAfterLogo}
                </p>
              ) : (
                <p className="intro-card-text">{card.text}</p>
              )}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}